import React, { Component } from "react";
import { Link } from 'react-router-dom';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp  } from "react-icons/fi";
import Helmet from "../component/common/Helmet";


import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";





const Portfolio_image = <img src="/assets/images/others/Elsons-1.jpg" alt="React Creative Agency" />;
const Portfolio_image2 = <img src="/assets/images/others/jack-fur.jpg" alt="React Creative Agency" />;
const Portfolio_image3 = <img src="/assets/images/others/Ek-1.jpg" alt="React Creative Agency" />;
const Portfolio_image4 = <img src="/assets/images/others/farmington-1.jpg" alt="React Creative Agency" />;
const Portfolio_image5 = <img src="/assets/images/others/farmington-2.jpg" alt="React Creative Agency" />;
const Portfolio_image6 = <img src="/assets/images/others/periapeak-3.jpg" alt="React Creative Agency" />;

const PortfolioList = [
    {
        image: Portfolio_image,
        category: 'Elsons Bombay Dyeing'
    },
    {
        image: Portfolio_image2,
        category: 'Jackfurniture'
    },
    {
        image: Portfolio_image3,
        category: 'Educkshethra'
    },
    {
        image: Portfolio_image4,
        category: 'Farmington'
    },
    {
        image: Portfolio_image5,
        category: 'Farmington'
    },
    {
        image: Portfolio_image6,
        category: 'Peria Peak Tea'
    },
]







const Portfolio_image8 = <img src="/assets/images/others/vw-1.jpg" alt="React Creative Agency" />;
const Portfolio_image9 = <img src="/assets/images/others/farmington-3.jpg" alt="React Creative Agency" />;
const Portfolio_image10 = <img src="/assets/images/others/transasia-1.jpg" alt="React Creative Agency" />;
const Portfolio_image11 = <img src="/assets/images/others/Elsons-2.jpg" alt="React Creative Agency" />;
const Portfolio_image12 = <img src="/assets/images/others/navya-1.jpg" alt="React Creative Agency" />;
const Portfolio_image13 = <img src="/assets/images/others/periapeak-1.jpg" alt="React Creative Agency" />;

const PortfolioList1 = [
    {
        image: Portfolio_image8,
        category: 'Volkswagon'
    },
    {
        image: Portfolio_image9,
        category: 'Farmington'
    },
    {
        image: Portfolio_image10,
        category: 'Transasia'
    },
    {
        image: Portfolio_image11,
        category: 'Elsons Bombay Dyeing'
    },
    {
        image: Portfolio_image12,
        category: 'Navya Bakeshop'
    },
    {
        image: Portfolio_image13,
        category: 'Peria Peak Tea'
    },

]


class InteriorLanding extends Component{


    stickyHeader () {}
    render(){





        return(
            <React.Fragment>
                <Helmet pageTitle="Other Works" />
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

    
                {/* Start Finding Us Area  */}
                <div className="rn-finding-us-area attacment-fixed rn-finding-us ptb--120 bg_color--1 bg_image bg_image--others" data-black-overlay="5">
                <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">Other Projects</h2>
                                  <p>We team LEONART paves the way to structure, design, present, establish our responsibility in the
multicolored canvas of technology and expertise in the suitable and apt position and period.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Finding Us Area  */}


                {/* Start Portfolio Area */}
                <div className="portfolio-area ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row mt_dec--30">
                            {PortfolioList.map((value , index) => (
                                <div className="col-lg-4 col-md-4 col-12 mt--30" key={index}>
                                    <div className="im_portfolio">
                                        <div className="thumbnail_inner">
                                            <div className="thumbnail">
                                                <Link to="#">
                                                    {value.image}
                                                </Link>    
                                            </div>
                                        </div>
                                        <div className="content">
                                            <div className="inner">
                                                <div className="portfolio_heading">
                                                    <div className="category_list">
                                                        <Link to="#">{value.category}</Link>
                                                    </div>
                                                </div>
                                                <div className="portfolio_hover">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                {/* End Portfolio Area */}



                 {/* Start Finding Us Area  */}
                 <div className="rn-finding-us-area attacment-fixed rn-finding-us ptb--120 bg_color--1 bg_image bg_image--others" data-black-overlay="5">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 offset-lg-2">
                                <div className="inner">
                                    <div className="content-wrapper">
                                   
                                    </div>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>
                {/* End Finding Us Area  */}

                
                {/* Start Portfolio Area */}
                    <div className="portfolio-area ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row mt_dec--30">
                            {PortfolioList1.map((value , index) => (
                                <div className="col-lg-4 col-md-4 col-12 mt--30" key={index}>
                                    <div className="im_portfolio">
                                        <div className="thumbnail_inner">
                                            <div className="thumbnail">
                                                <Link to="#">
                                                    {value.image}
                                                </Link>    
                                            </div>
                                        </div>
                                        <div className="content">
                                            <div className="inner">
                                                <div className="portfolio_heading">
                                                    <div className="category_list">
                                                        <Link to="#">{value.category}</Link>
                                                    </div>
                                                </div>
                                                <div className="portfolio_hover">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                {/* End Portfolio Area */}


                 {/* Start Footer Style  */}
                 <Footer />
                {/* End Footer Style  */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                </React.Fragment>
        )
    }
}

export default InteriorLanding;